import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-black text-white">
      <div className="px-6 py-12">
        {/* Logo and Description */}
        <div className="text-center mb-12">
          <h3 className="text-3xl font-serif font-bold tracking-[0.4em] text-white mb-6">
            ELARA
          </h3>
          <p className="text-gray-300 text-sm max-w-md mx-auto leading-relaxed font-light">
            Curating exceptional luxury handbags for the discerning woman who values craftsmanship and timeless elegance.
          </p>
        </div>

        {/* Instagram Link */}
        <div className="text-center mb-10">
          <h4 className="text-sm font-medium mb-6 text-white tracking-wide uppercase">
            Follow Us
          </h4>
          <a
            href="https://www.instagram.com/elara_premium"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-300 hover:text-white transition-colors text-sm font-light tracking-wide"
          >
            Instagram
          </a>
        </div>

        {/* Contact Info */}
        <div className="text-center mb-10 space-y-3">
          <div className="text-gray-300 text-sm font-light">
            <p>hello@elara-premium.com</p>
          </div>
          <div className="text-gray-300 text-sm font-light">
            <p>Kathmandu, Nepal</p>
          </div>
        </div>

        {/* Bottom section */}
        <div className="border-t border-gray-800 pt-8 text-center">
          <div className="text-gray-400 text-xs font-light tracking-wide">
            © 2024 Elara Premium. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;